import Api from './api'

const resource = '/emotes'
export default {
  get() {
    return Api.get(`${resource}/index`)
  },
  create(data) {
    let payload = new FormData();
    payload.append('name', data.name)
    payload.append('file', data.file)

    return Api.post(`${resource}/store`, payload)
  },
  destroy(emoteName) {
    return Api.delete(`${resource}/destroy/${emoteName}`)
  }
}
